import { DecimalPipe } from "@angular/common";
import { Component, HostBinding, Input, ChangeDetectionStrategy } from "@angular/core";

import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-indicator-number",
	templateUrl: "./indicator-number.component.html",
	styleUrls: ["./indicator-number.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [DecimalPipe]
})
export class IndicatorNumberComponent {
	@Input()
	frame: APIResults.FlightPathFrame;
	@Input()
	field: string;
	@Input()
	label: string;
	@Input()
	units: string;

	@HostBinding("hidden") get hidden() { return !(this.frame && this.frame[this.field] !== undefined); }
	@HostBinding("class") classes = "col-lg-3 col-sm-6";
}
